const selectors = {
  description: '[data-collection-footer-collapsible]',
  descriptionToggle: '[data-collection-footer-toggle]',
};

export default function initCollectionDescriptionToggle(container) {
  const description = container.querySelector(selectors.description);
  const descriptionToggle = container.querySelector(selectors.descriptionToggle);

  if (!description || !descriptionToggle) return;

  let isExpanded = false;

  descriptionToggle.addEventListener('click', () => {
    description.style.height = isExpanded ? '0' : `${description.scrollHeight}px`;
    description.style.opacity = isExpanded ? '0' : '1';
    isExpanded = !isExpanded;
    descriptionToggle.ariaExpanded = isExpanded;
    descriptionToggle.textContent = isExpanded
      ? window.theme?.strings?.collection?.readLess
      : window.theme?.strings?.collection?.readMore;
  });
}
